/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Apis_Space_Col_ProjectsInputs */



/**
* | output |
* | --- |
* | "Projects" |
*
* @param {External_Apis_Space_Col_ProjectsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_space_col_projects = /** @type {((inputs?: External_Apis_Space_Col_ProjectsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Space_Col_ProjectsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekte")
	return /** @type {LocalizedString} */ ("Projects")
});